export enum HomebaseEvents {
  LEVEL_UP = 'level_up',
  LATEST_ACTIVITY = 'click_latest_activity_button',
  LATEST_ACTIVITY_TAB = 'click_latest_activity_tab',
  LEARNING_PATH_TAB = 'click_learning_path_tab',
  OPEN_PET_VIEW = 'pet_view_open',
  CLOSE_PET_VIEW = 'pet_view_close',
}

// other methods of opening the pet view exists in playcanvas. That is why method parameter is needed
export enum PetViewOpenCloseMethods {
  TAB = 'tab',
}
